<template>
  <div class="publicTransferDetails">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="640px"
      :before-close="handleClose"
    >
      <template v-if="status === 'details'">
        <el-form ref="formInline" :model="formInline" label-width="120px">
          <el-form-item label="班级名称:">
            {{ formInline.skuName }}
          </el-form-item>
          <el-form-item label="支付金额:">
            {{ formInline.payAmt }}
          </el-form-item>
          <el-form-item label="订单编号:">
            {{ formInline.orderNumber }}
          </el-form-item>
          <el-form-item label="转账人:">
            {{ formInline.remitterName }}
          </el-form-item>
          <el-form-item label="收款商户名称:">
            {{ formInline.gatheringName }}
          </el-form-item>
          <el-form-item label="收款账号:">
            {{ formInline.gatheringNumber }}
          </el-form-item>
          <el-form-item label="支付凭证:">
            <div class="flx">
              <div
                class="flx_inner"
                v-for="(item, index) in formInline.remitterVoucher"
                :key="index"
              >
                <el-image
                  style="width: 80px; height: 80px"
                  :src="item"
                  :preview-src-list="[item]"
                >
                </el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="审核状态:" prop="auditStatus">
            <span v-if="formInline.auditStatus === 2">通过</span>
            <span v-else-if="formInline.auditStatus === 3">驳回</span>
            <span v-else>--</span>
          </el-form-item>
          <el-form-item
            v-if="formInline.auditStatus === 3 || formInline.auditNote"
            label="审核意见:"
            prop="auditNote"
          >
            {{ formInline.auditNote }}
          </el-form-item>
          <el-form-item
            v-if="formInline.auditStatus === 2"
            label="支付时间:"
            prop="payTimeStr"
          >
            {{ formInline.payTimeStr }}
          </el-form-item>
          <el-form-item label="审核时间:" prop="auditDate">
            {{ formInline.auditDate }}
          </el-form-item>
          <el-form-item label="审核人:" prop="auditorName">
            {{ formInline.auditorName }}
          </el-form-item>
        </el-form>
      </template>
      <template v-else-if="status === 'reason'">
        <div>{{ formInline.auditNote }}</div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          v-if="status === 'reason'"
          type="primary"
          @click="openUploadCertificate"
          >重新上传凭证</el-button
        >
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 上传凭证 -->
    <UploadCertificate ref="uploadCertificateRef" />
  </div>
</template>

<script>
import UploadCertificate from "@/views/orderAdmin/components/uploadCertificate.vue";
import { getAuditInfoByOrderId } from "@/api/orderAdmin/orderList";
import { getPrivateImgUrl } from '@/api/product/base'
export default {
  components: {
    UploadCertificate,
  },
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        skuName: "",
        payAmt: "",
        orderNumber: "",
        remitterName: "",
        gatheringName: "",
        gatheringNumber: "",
        remitterVoucher: [],
        auditStatus: "",
        auditNote: "",
        payTimeStr: "",
        auditDate: "",
        auditorName: "",
      },
      orderId: "",
      status: "",
      itemData: {},
    };
  },
  methods: {
    // 初始化
    async init(status, payload) {
      this.itemData = payload;
      this.dialogTitle = status === "details" ? "审核详情" : "驳回原因";
      this.status = status;
      this.orderId = payload.id;
      const res = await getAuditInfoByOrderId({ orderId: payload.id });
      this.formInline = {
        skuName: payload.skuName || "",
        payAmt: payload.payAmt || "",
        orderNumber: res.data?.orderNumber || "",
        remitterName: res.data?.remitterName || "",
        gatheringName: res.data?.gatheringName || "",
        gatheringNumber: res.data?.gatheringNumber || "",
        remitterVoucher: [],
        auditStatus: res.data?.auditStatus || "",
        auditNote: res.data?.auditNote || "",
        payTimeStr: res.data?.payTime || "",
        auditDate: res.data?.auditDate || "",
        auditorName: res.data?.auditorName || "",
      };
      const list = res.data?.remitterVoucher?.split(",") || []
      list.filter(item => {
        getPrivateImgUrl(item).then(res => {
          this.formInline.remitterVoucher.push(res.data)
        })
      })
      this.dialogVisible = true;
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
    },
    // 重新上传凭证
    openUploadCertificate() {
      this.$refs.uploadCertificateRef.init(this.itemData);
    },
    // 刷新
    refresh() {
      this.$emit("refresh");
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.publicTransferDetails {
  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 20px 30px;
  }
  .flx {
    display: flex;
    flex-wrap: wrap;
    .flx_inner {
      margin: 0 6px;
    }
  }
}
</style>
